// store/modules/banners.js
import PromoBannerService from "@/store/services/promobanner.service";

export default {
  namespaced: true,
  state: {
    banners: []
  },
  getters: {
    // Banners are pre-filtered server-side by user eligibility.
    // Client-side we only need to filter by the page slot.
    bannersForPage: state => (page) => {
      if (!page) return []

      const pageName = String(page).toLowerCase()

      return (state.banners || [])
        .filter(banner => {
          if (
            !banner ||
            !Array.isArray(banner.target_apps) ||
            !banner.target_apps.some(app => String(app).toLowerCase() === 'web')
          ) {
            return false
          }

          if (!Array.isArray(banner.pages)) return false
          return banner.pages.some(p => String(p).toLowerCase() === pageName)
        })
        .sort((a, b) => (b.priority || 0) - (a.priority || 0))
    },
  },
  mutations: {
    SET_BANNERS (state, banners) {
      state.banners = Array.isArray(banners) ? banners : []
    },
    CLEAR_BANNERS (state) {
      state.banners = []
    }
  },
  actions: {
    fetchActiveBanners ({ commit }, params = {}) {
      return PromoBannerService.list(params).then(response => {
        commit('SET_BANNERS', response.data)
      })
    },
    clearBanners ({ commit }) {
      commit('CLEAR_BANNERS')
    }
  }
}

// ---------------------------------------------------------------------------
// EXAMPLE / FAKE DATA (for local dev or reference — do not delete)
// ---------------------------------------------------------------------------
// fetchActiveBanners ({ commit }) {
//   const bannersData = [
//     {
//       id: 42,
//       title: "Upgrade to Premium & Save 20%",
//       template: "base",
//       priority: 100,
//       is_closeable: true,
//       html_content: {
//         nl: '<div class="promo-intro">Promointroductie</div><div>Upgrade vandaag en ontvang <strong>20% korting</strong>!</div>',
//         es: '<div class="promo-intro">Introducción de la promoción</div><div>Actualiza hoy y recibe un <strong>20% de descuento</strong>.</div>',
//         en: '<div class="promo-intro">Promotion intro</div><div>Upgrade today and get <strong>20% off</strong>!</div>',
//         pl: '<div class="promo-intro">Wprowadzenie do promocji</div><div>Ulepsz już dziś i odbierz <strong>20% zniżki</strong>!</div>',
//       },
//       target_app: "web",
//       pages: ["dashboard", "subscriptions"],
//       linked_discount: {
//         id: 7,
//         code: "PREMIUM20",
//         percentage: 20,
//         valid_from: "2025-01-01T00:00:00Z",
//         valid_until: "2026-01-31T23:59:59Z",
//       },
//       link_url: '/costs',
//       opens_modal: false,
//       modal_html_content: {
//         nl: "<div><h2>Premium voordelen</h2></div>",
//         es: "<div><h2>Ventajas Premium</h2></div>",
//         en: "<div><h2>Premium Benefits</h2></div>",
//         pl: "<div><h2>Zalety Premium</h2></div>",
//       },
//       countdown: {
//         show_countdown: true,
//         start_datetime: null,
//         end_datetime: null,
//         derived_from_discount: true,
//       },
//       targeting: {
//         valid_for: "not_premium",
//         event: "signup",
//         days_valid_after_event: 7,
//         starts_after_event: 0,
//         country: ["NL", "BE", "DE"],
//       },
//       created_at: "2024-12-10T14:22:11Z",
//       updated_at: "2024-12-15T09:03:45Z",
//       is_active: true,
//     },
//     {
//       id: 43,
//       title: "Manage your costs faster",
//       template: "blackfriday",
//       priority: 80,
//       is_closeable: false,
//       html_content: {
//         nl: '<div class="promo-intro">Kosten</div><div>Bekijk je <strong>kostenoverzicht</strong> en exporteer met één klik.</div>',
//         es: '<div class="promo-intro">Costes</div><div>Revisa tu <strong>resumen de costes</strong> y exporta con un clic.</div>',
//         en: '<div class="promo-intro">Costs</div><div>Review your <strong>cost overview</strong> and export in one click.</div>',
//         pl: '<div class="promo-intro">Koszty</div><div>Sprawdź <strong>podsumowanie kosztów</strong> i eksportuj jednym kliknięciem.</div>',
//       },
//       target_app: "web",
//       pages: ["costs"],
//       linked_discount: {
//         id: 8,
//         code: "COSTS10",
//         percentage: 10,
//         valid_from: "2025-06-01T00:00:00Z",
//         valid_until: "2026-06-01T23:59:59Z",
//       },
//       link_url: null,
//       opens_modal: true,
//       modal_html_content: {
//         nl: "<div><h2>Kostenoverzicht</h2></div>",
//         es: "<div><h2>Resumen de costes</h2></div>",
//         en: "<div><h2>Cost overview</h2></div>",
//         pl: "<div><h2>Podsumowanie kosztów</h2></div>",
//       },
//       countdown: {
//         show_countdown: true,
//         start_datetime: "2025-01-01T00:00:00Z",
//         end_datetime: "2026-02-31T23:59:59Z",
//         derived_from_discount: false,
//       },
//       targeting: {
//         valid_for: "all",
//         event: "user_logged_in",
//         days_valid_after_event: 30,
//         starts_after_event: 0,
//         country: ["NL", "BE", "DE", "ES", "PL"],
//       },
//       created_at: "2024-12-11T08:10:00Z",
//       updated_at: "2024-12-15T10:15:00Z",
//       is_active: true,
//     }
//   ]
//   commit("SET_BANNERS", bannersData)
// },